import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import classNames from 'classnames';
import { charcoalGrey, universalStyles, white } from '../../../../app/theme';

const useStyles = makeStyles(() => ({
  ...universalStyles,
  pageList: {
    marginBottom: 30,
  },
  whiteText: {
    color: white,
  },
  grayBox: {
    backgroundColor: charcoalGrey,
    marginTop: 32,
    marginBottom: 50,
    paddingTop: 20,
    paddingBottom: 50,
    paddingLeft: 43,
    paddingRight: 89,
  },
  header: {
    color: white,
    fontSize: 20,
    fontWeight: 900,
  },
}));

const InterpretationPage01 = (): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="h6">
        This training is designed to help physicians understand the image acquisition and interpretation criteria for
        Axumin.
      </Typography>
      <div className={classes.grayBox}>
        <Typography className={classes.header}>The Image Interpretation Training contains the following:</Typography>
        <ul className={classNames(classes.list, classes.whiteText, classes.pageList)}>
          <li>Steps needed for better identification and interpretation of prostate cancer lesions</li>
          <li>Learning check questions to ensure understanding of all the training materials</li>
          <ul className={classNames(classes.nestedList, classes.whiteText)}>
            <li>
              These are ungraded practice questions intended to improve physician learning and keep you engaged
              throughout the training
            </li>
          </ul>
          <li>
            Clinical case studies, which follow patients from clinical presentation, imaging (including videos), and,
            finally, image findings
          </li>
        </ul>
        <Typography className={classes.header}>
          We encourage all participants to set aside 90 minutes to complete this training. If you are interrupted or
          logged out, you will be redirected to the last web-page you reviewed upon returning to this training track.
          <br />
          <br />
          <i>To gain access to additional materials, please be sure to fully complete this training.</i>
        </Typography>
      </div>
    </>
  );
};

export default InterpretationPage01;
